import { Action } from 'redux';
import { Mask } from '@/types';

export enum MasksActionTypes {
  MASKS_FETCH = '@masks/fetch',
}

export interface MasksFetchAction extends Action {
  type: MasksActionTypes.MASKS_FETCH;
  masks: Mask[];
}

export type MasksActions = MasksFetchAction;
